import { requestsClient } from '@/shared/api';

import { ICreateAccountMutationParams } from './types';

export const createAccountMutation = async ({
  currencyId,
  accountId,
}: ICreateAccountMutationParams) => {
  const { vabsAccCreateMyAccountBalances } =
    await requestsClient.vabsAccCreateMyAccountBalances({
      input: {
        currencyIds: [currencyId],
        virtualAccountId: accountId,
      },
    });
  return vabsAccCreateMyAccountBalances;
};
